'use client'

import { useMemo } from 'react'

import { IEmployee, TEAM_CATEGORY_TYPE_ENUM } from '@/_types'

import AEmployeeHeroInfoLanguages from './a-employee-hero-info-languages'
import AEmployeeHeroInfoMinimumAge from './a-employee-hero-info-minimum-age'

interface IProps {
	employee: IEmployee
}

export default function AEmployeeHeroInfo({ employee }: IProps) {
	const isMedicalPersonnel = useMemo(() => {
		return employee.categories?.some(
			category => category.type === TEAM_CATEGORY_TYPE_ENUM.MEDICAL_PERSONNEL
		)
	}, [employee.categories])

	if (!isMedicalPersonnel) {
		return null
	}

	return (
		<>
			<AEmployeeHeroInfoLanguages languages={employee.languages} />

			<AEmployeeHeroInfoMinimumAge
				minAge={employee.minimumPatientAge}
				maxAge={employee.maximumPatientAge}
			/>
		</>
	)
}
